import { Chat, FacebookLogo, LinkedinLogo, XLogo } from '@phosphor-icons/react'
import Link from 'next/link'

export function Footer() {
  return (
    <footer className='w-full py-8'>
      <div className='container mx-auto px-4'>
        <div className='flex flex-col items-center justify-center space-y-6'>
          {/* Logo */}
          {/* <div className='mb-2'>
            <Image
              src='/placeholder.svg?height=40&width=40'
              alt='Mapstack Logo'
              width={40}
              height={40}
              className='h-10 w-auto'
            />
          </div> */}

          {/* Social Media Icons */}
          <div className='flex items-center space-x-4 text-gray-600'>
            <Link
              href='https://twitter.com/mapstack_io'
              aria-label='Twitter'
            >
              <XLogo className='h-5 w-5' />
            </Link>
            <Link
              href='https://www.linkedin.com/company/mapstack/'
              aria-label='LinkedIn'
            >
              <LinkedinLogo className='h-5 w-5' />
            </Link>
            <Link
              href='https://www.facebook.com/mapstack.io'
              aria-label='Facebook'
            >
              <FacebookLogo className='h-5 w-5' />
            </Link>
          </div>

          {/* Copyright Text */}
          <div className='text-center text-sm text-gray-600 max-w-2xl'>
            <p>
              ©2023 Mapstack. 1 Victoria Street, Bristol, England, BS1 6AA, UK
            </p>
            <p className='mt-2'>
              When you visit or interact with our sites, services or tools, we
              or our authorised service providers may use cookies for storing
              information to help provide you with a better, faster and safer
              experience and for marketing purposes.
            </p>
          </div>

          {/* Footer Links */}
          <div className='flex flex-wrap justify-center gap-x-6 text-sm'>
            <Link
              href='https://blog.mapstack.io'
              className='text-gray-600 hover:text-gray-900'
            >
              Blog
            </Link>
            <Link
              href='/privacy'
              className='text-gray-600 hover:text-gray-900'
            >
              Privacy policy
            </Link>
            <Link
              href='/terms'
              className='text-gray-600 hover:text-gray-900'
            >
              Terms of service
            </Link>
            <Link
              href='/workspaces'
              className='text-gray-600 hover:text-gray-900'
            >
              Workspaces
            </Link>
            <Link
              href='/tags'
              className='text-gray-600 hover:text-gray-900'
            >
              Tags
            </Link>
            <Link
              href='mailto:support@mapstack.io'
              className='text-gray-600 hover:text-gray-900'
            >
              Contact us
            </Link>
          </div>
        </div>
      </div>

      {/* Chat Bubble */}
      <div className='fixed bottom-6 left-6 z-50'>
        <button
          className='flex h-12 w-12 items-center justify-center rounded-full bg-blue-500 text-white shadow-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
          aria-label='Chat with us'
        >
          <Chat className='h-6 w-6' />
        </button>
      </div>
    </footer>
  )
}
